<template>
  <div class="metrics-container">
    <MetricsContainer title="Position" :value="coordinates" class="w-100"></MetricsContainer>
    <MetricsContainer title="Vent" :value="wind" class="w-100"></MetricsContainer>
    <MetricsContainer title="Pression" :value="pression" class="w-100"></MetricsContainer>
    <MetricsContainer title="Température" :value="temp" class="w-100"></MetricsContainer
    ><MetricsContainer title="Heure" :value="hour" class="w-100"></MetricsContainer>
  </div>
</template>
<script>
import MetricsContainer from "@/components/customContainer/MetricsContainer.vue";
/*Mixins*/
import Utils from "@/mixins/utils.js";
/*Lib*/
import axios from 'axios'

export default {
  mixins: [Utils],
  data() {
    return {
      coordinates: null,
      wind: null,
      pression: null,
      temp: null,
      hour: null,
      lat:null,
      lng:null,
      intervals: {
        time: null,
      },
    };
  },
  methods: {
    getMeteo(vm){
      let lat = 46
      let lng =-71
      if(this.lat && this.lng ){
        lat=this.lat
        lng=this.lng
      }
        axios.get('https://api.open-meteo.com/v1/forecast?latitude='+lat+'&longitude='+lng+'&current=temperature_2m,wind_speed_10m,wind_direction_10m,surface_pressure,surface_pressure').then((response)=>{
            vm.wind=response.data.current.wind_speed_10m + 'km/h'
            vm.temp=response.data.current.temperature_2m + ' C'
            vm.pression=response.data.current.surface_pressure+ 'hPa'
            vm.$store.commit("wind_speed", response.data.current.wind_speed_10m);
            vm.$store.commit("wind_dir", response.data.current.wind_direction_10m);
        })
    }
  },
  components: {
    MetricsContainer,
  },
  mounted() {
    let vm = this;
    this.intervals.time = setInterval(function () {
      vm.hour = vm.currentTime();
    }, 1000);
    vm.getPosition(
        (position) =>
          (vm.coordinates =
            position.coords.longitude + ", " + position.coords.latitude)
      );
    vm.getMeteo(vm)
    this.intervals.position = setInterval(function () {
      vm.getMeteo(vm)
      vm.getPosition(
        (position) =>
          (vm.coordinates =
            position.coords.longitude + ", " + position.coords.latitude)
      );
    }, 5000);
  },
};
</script>
<style scoped>
.metrics-container {
  display: flex;
  width:100%;
}
</style>
